import { gql } from '@apollo/client';

export type Profile = {
  id: string;
  maritalStatus: 'unmarried' | 'married' | 'divorced_or_bereavement';
  gender: 'male' | 'female';
  widowClassification?: WidowClassification;
};

export type WidowClassification = {
  id: string;
  classification: 'none' | 'normal' | 'special' | 'single_parent';
  detail?: string;
};

export type QueryResult = {
  request: {
    id: string;
    profile: Profile;
  };
};

export const FETCH_REQUEST_PROFILE_WIDOW = gql`
  query basicInformation {
    request {
      id
      profile {
        id
        maritalStatus
        gender
        widowClassification {
          id
          classification
        }
      }
    }
  }
`;
